"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9606],{

/***/ 67083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useLogin; }
/* harmony export */ });
/* unused harmony export AuthError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70655);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48228);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _app_hooks_useUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84513);
/* harmony import */ var _utilities_fetcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17471);








var AuthError;
(function(AuthError) {
    AuthError["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AuthError["NOT_ALLOWED"] = "NOT_ALLOWED";
})(AuthError || (AuthError = {}));
function useLogin(redirect) {
    var checkRoles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), authError = ref[0], setAuthError = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var login = (0,_app_hooks_useUser__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .a)().login;
    var mutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)(function(data) {
        setAuthError(undefined);
        (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)("refresh_token");
        return (0,_utilities_fetcher__WEBPACK_IMPORTED_MODULE_4__/* .fetcher */ ._)("/account/login", {
            method: "POST",
            body: JSON.stringify({
                email: data.email.toLowerCase(),
                password: data.password
            })
        });
    }, {
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(data, variables, context) {
                var e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                login(data.token, checkRoles)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                router.push(redirect)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            setAuthError(AuthError.NOT_ALLOWED);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data, variables, context) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            setAuthError(AuthError.INVALID_CREDENTIALS);
        }
    });
    return {
        error: authError,
        login: mutation.mutate,
        loading: mutation.isLoading
    };
}


/***/ }),

/***/ 84513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66252);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48228);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96245);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _app_store_useStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99827);
/* harmony import */ var _utilities_fetcher__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17471);










function useUser() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var apolloClient = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useApolloClient */ .x)();
    var ref = (0,_app_store_useStore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.user;
    }), loginWithUserData = ref.loginWithUserData, login = ref.login, logout = ref.logout, data = ref.data;
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useMutation */ .D)(function() {
        return (0,_utilities_fetcher__WEBPACK_IMPORTED_MODULE_5__/* .fetcher */ ._)("/account/token/refresh", {
            method: "POST"
        });
    }, {
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
                var token;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = param.token;
                            return [
                                4,
                                doLogin(token)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }), mutateAsync = ref1.mutateAsync, isRefreshingToken = ref1.isLoading;
    var doLogout = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var noRedirect, redirectTo, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    noRedirect = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, redirectTo = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "/account/login";
                    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)("nxtlvl-token");
                    return [
                        4,
                        fetch("/account/logout", {
                            credentials: "same-origin"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        5
                    ];
                    logout();
                    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)("refresh_token");
                    if (!!noRedirect) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        router.push(redirectTo)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        apolloClient.resetStore()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        router,
        logout,
        apolloClient
    ]);
    var doLogin = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(token) {
            var checkRoles, data;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkRoles = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : [];
                        (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)("nxtlvl-token", token);
                        if (!checkRoles) return [
                            3,
                            4
                        ];
                        data = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(token);
                        if (!checkRoles.every(function(role) {
                            return data.roles.includes(role);
                        })) return [
                            3,
                            1
                        ];
                        loginWithUserData(data);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            doLogout(true)
                        ];
                    case 2:
                        _state.sent();
                        throw new Error("Not allowed");
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        login(token);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(token) {
            return _ref.apply(this, arguments);
        };
    }(), [
        login,
        doLogout,
        loginWithUserData
    ]);
    return {
        login: doLogin,
        logout: doLogout,
        refreshToken: mutateAsync,
        isRefreshingToken: isRefreshingToken,
        user: data
    };
}


/***/ }),

/***/ 92869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cC": function() { return /* reexport */ Trans/* Trans */.c; },
  "$G": function() { return /* reexport */ useTranslation/* useTranslation */.$; }
});

// UNUSED EXPORTS: default

// NAMESPACE OBJECT: ./src/locales/de/index.ts
var de_namespaceObject = {};
__webpack_require__.r(de_namespaceObject);
__webpack_require__.d(de_namespaceObject, {
  "admin": function() { return admin_namespaceObject; },
  "auth": function() { return auth_namespaceObject; },
  "certificate": function() { return certificate_namespaceObject; },
  "common": function() { return common_namespaceObject; },
  "errors": function() { return errors_namespaceObject; },
  "layout": function() { return layout_namespaceObject; },
  "management": function() { return management_namespaceObject; },
  "page_homepage": function() { return page_homepage_namespaceObject; },
  "readingHabits": function() { return readingHabits_namespaceObject; },
  "validation": function() { return validation_namespaceObject; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatRelative/index.js + 21 modules
var formatRelative = __webpack_require__(88401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 15 modules
var i18next = __webpack_require__(60923);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 3 modules
var context = __webpack_require__(65091);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 4 modules
var Trans = __webpack_require__(99955);
;// CONCATENATED MODULE: ./src/locales/de/admin.json
var admin_namespaceObject = JSON.parse('{"account":{"verified":"Account bestätigt","unverified":"Account unbestätigt","notConnected":"Kein Account verknüpft","readingHabit":"Leseumfrage ja","noReadingHabit":"Leseumfrage nein"},"nativeSpeaker":{"label":"Muttersprache","labelWithValue":"$t(admin:nativeSpeaker.label): $t(admin:nativeSpeaker.values.{{value}})","values":{"NO":"nein","YES":"ja"}},"readsInFreeTime":{"label":"Liest in Freizeit","labelWithValue":"$t(admin:readsInFreeTime.label): $t(admin:readsInFreeTime.values.{{value}})","values":{"NO":"nein","YES":"ja"}},"readingSkill":{"label":"Lesefähigkeit","labelWithValue":"$t(admin:readingSkill.label): $t(admin:readingSkill.values.{{value}})","values":{"LOW":"gering","GOOD":"gut","FLUENT":"flüssig"}},"booksReadYearly":{"label":"Bücher pro Jahr","labelWithValue":"$t(admin:booksReadYearly.label): $t(admin:booksReadYearly.values.{{value}})","values":{"ZERO_TO_FIVE":"0-5","FIVE_TO_TEN":"5-10","TEN_TO_FIFTEEN":"10-15","MORE_THAN_FIFTEEN":"> 15"}},"readingRelatives":{"label":"Lesende Verwandte","labelWithValue":"$t(admin:booksReadYearly.label): {{values}}","values":{"GRANDFATHER":"Oma","GRANDMOTHER":"Opa","SIBLING":"Geschwister","MOTHER":"Mutter","FATHER":"Vater","NONE":"Keine"}},"graphs":{"legend":{"readPages":"Gelesene Seiten"}},"studentDetails":{"changeSchoolAndClass":{"school":"Schule","schoolClass":"Klasse","warning":"Das bisherige Lese-Protokoll wird der neuen Klasse und Schule zugeordnet!","submit":"Zuordnung ändern","notification":{"success":{"title":"Klassenzuordnung geändert","message":"Die Klassenzuordnung wurde geändert und das Lese-Protokoll neu zugeordnet"}}},"readAchievements":{"delete":{"submit":"Löschen","confirm":{"title":"Lese-Eintrag entfernen?","message":"Wenn Sie diesen Lese-Eintrag löschen, werden dadurch erreichte Level ebenfalls gelöscht."},"notification":{"success":{"title":"Lese-Eintrag entfernt","message":"Der Lese-Eintrag wurde erfolgreich gelöscht."}}}}},"studentsList":{"student":{"delete":{"submit":"Löschen","confirm":{"title":"Schüler:in entfernen?","message":"Möchten Sie <strong>{{student}}</strong> wirklich löschen? <br/> <br/> Wenn Sie diese Schüler:in löschen, werden alle Lese-Erfolge mit gelöscht."},"notification":{"success":{"title":"Schüler:in entfernt","message":"Der Datensatz wurde erfolgreich gelöscht."}}}}},"usersList":{"user":{"delete":{"submit":"Löschen","confirm":{"title":"User entfernen?","message":"Wenn Sie diesen User löschen, hat dieser keinen Zugriff mehr."},"notification":{"success":{"title":"User entfernt","message":"Der Datensatz wurde erfolgreich gelöscht."}}},"invite":{"buttonReInvite":"Erneut einladen","notification":{"success":{"title":"User eingeladen","message":"Der User wurde erfolgreich eingeladen."}}}}},"role":{"ROLE_USER":"User","ROLE_SUPERADMIN":"Superadmin","ROLE_ADMIN":"Admin","ROLE_ADMIN_ACCESS":"Admin-Zugang","ROLE_STUDENT":"Schüler","ROLE_TEACHER":"Lehrer"}}');
;// CONCATENATED MODULE: ./src/locales/de/auth.json
var auth_namespaceObject = JSON.parse('{"login":{"headline":"Hallo 👋","subheadline":"Du hast noch keinen Account? <registerLink>Account erstellen</registerLink>.","forgotPassword":"Passwort vergessen?","sessionExpired":"Deine Sitzung ist abgelaufen. Bitte melde dich neu an.","form":{"submit":"Anmelden","fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"},"password":{"label":"Passwort","placeholder":"Dein Passwort"}}}},"register":{"headline":"Neu hier?","subheadline":"Dann erstelle dir einen Account. <br /> Du hast schon Einen? Dann <loginLink>melde dich an</loginLink>.","infoForEmail":"Vermeide Tippfehler bei deiner E-Mail-Adresse. Denn wenn du sie falsch eingibst, kannst du dich bei Next Level nicht anmelden.","form":{"submit":"Account erstellen","sections":{"loginData":"Daten zum Anmelden","studentData":"Informationen über Dich"},"fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"},"password":{"label":"Passwort","placeholder":"Dein gewünschtes Passwort"},"passwordRepeat":{"label":"Passwort wiederholen","placeholder":"Passwort wiederholen"},"givenName":{"label":"Vorname","placeholder":"Vorname"},"familyName":{"label":"Nachname","placeholder":"Nachname"},"school":{"label":"Schule","placeholder":"Wähle deine Schule"},"schoolClass":{"label":"Klasse","placeholder":"Wähle deine Klasse","groupName":"{{grade}}. Klasse"},"nameOfLegalGuardian":{"label":"Vor- und Zuname des Erziehungsberechtigten","placeholder":""},"signedUpByLegalGuardian":{"label":"Ich als Erziehungsberechtigte(r) habe die Anmeldung für das Projekt Next Level der Stadtbibliothek Gütersloh gemeinsam mit meinem Kind durchgeführt.","placeholder":""}}}},"recover":{"pageTitle":"Passwort vergessen","title":"Passwort vergessen?","intro":"<firstParagraph>Es kann jedem mal passieren das Passwort zu vergessen. Das ist gar nicht schlimm. Wenn du die E-Mail-Adresse einträgst mit der du dich registriert hast, dann schicken wir dir eine E-Mail zu.</firstParagraph><secondParagraph>In der E-Mail ist dann ein Link den du anklicken musst. Und dann gelangst du zu einer Seite, wo du ein neues Passwort speichern kannst.</secondParagraph>","form":{"submit":"Absenden","fields":{"email":{"label":"E-Mail","placeholder":"email@domain.de"}}}},"invite":{"pageTitle":"User Einladung","title":"Einladung zum Admin Bereich","intro":"<firstParagraph>Sie wurden zum Admin-Bereich von Next Level eingeladen. Bitte wählen Sie ihr persönliches Passwort mit dem Sie sich danach im Admin-Bereich anmelden können.</firstParagraph>"},"recoverCheckEmail":{"pageTitle":"E-Mail überprüfen","title":"Überprüfe deine E-Mails","alert":{"title":"Anfrage versendet","text":"Wenn ein Konto existiert, das mit Deiner E-Mail-Adresse übereinstimmt, wurde soeben eine E-Mail mit einem Link verschickt, mit dem du dein Passwort zurücksetzen kannst. Der Link verliert in 1 Stunde seine Gültigkeit."},"spamHint":"Wenn du keine E-Mail erhältst, dann schaue bitte in deinem Spam-Ordner nach oder <recoverLink>versuche es noch einmal</recoverLink>."}}');
;// CONCATENATED MODULE: ./src/locales/de/certificate.json
var certificate_namespaceObject = JSON.parse('{"title":"Urkunde","salutation":"{{name}},","intro":"du hast bei NEXT LEVEL bereits {{pages, number}} Seiten gelesen und darfst jetzt stolz den Titel {{levelTitle}} tragen.","intro_1":"du hast bei NEXT LEVEL bereits 1 Buch gelesen und darfst jetzt stolz den Titel {{levelTitle}} tragen.","outro_3":"Entdecker:innen wie Christoph Kolumbus oder Jeanne Baré sind bei ihren Reisen in Regionen der Welt vorgedrungen, die zuvor weitgehend unbekannt waren. Sie haben mutig Neues gewagt und kehrten mit überraschenden Erkenntnissen und reich an Erfahrung heim. \\n\\nBist du auch mutig und neugierig? Dann wähle doch dein nächstes Buch mal aus einer anderen Rubrik aus. Bestimmt gibt es in der Mediothek noch viel Unbekanntes für dich zu entdecken!","outro_6":"Ein Meister ist eine Person, die durch außergewöhnliche Leistungen aufgefallen ist bzw. die sich zu einem bestimmten Fachgebiet besonders viel Wissen angeeignet hat. \\n\\nSo ist es auch bei dir: du hast {{pages, number}} Seiten gelesen, eine außergewöhnliche Lese-Leistung! Dabei hast du dich mit den Geschichten und Gedanken anderer Menschen vertraut gemacht und sicher Bücher entdeckt, die dir besonders gut gefallen haben. Gib deine Buchtipps an andere weiter, denn Meister:innen teilen ihr Wissen gerne!","outro_8":"Das Wort Guru kommt aus einer alt-indischen Sprache und bedeutet Lehrer bzw. Vorbild. Ein Guru teilt sein Wissen und hat viele Anhänger, die seinem Beispiel folgen. \\n\\nBestimmt motiviert es andere Kinder zu sehen, wieviel Spaß dir das Lesen macht. Hast du nicht Lust, einmal selbst eine Geschichte zu schreiben? \\n\\nProbier es doch mal aus!"}');
;// CONCATENATED MODULE: ./src/locales/de/common.json
var common_namespaceObject = JSON.parse('{"yes":"Ja","no":"Nein","cancel":"Abbrechen","delete":"Löschen","pages_other":"{{count, number}} Seiten","pages_one":"{{count, number}} Seite","books_other":"{{count, number}} Bücher","books_one":"{{count, number}} Buch","date":"{{date, datetime}}","dateRelative":"{{date, datetorelative}}","number":"{{number, number}}","readBooks":"Du hast $t(books) gelesen","readPagesOverall":"Du hast schon <strong>$t(pages)</strong> gelesen. <br> dein Bücherstapel ist <strong>{{count, stacksize, unit}}</strong> hoch.","readPagesOverall_zero":"Du hast im Projekt noch kein Buch gelesen. <br> Sobald du dein erstes Buch erfasst hast, siehst du hier wie hoch dein Bücherstapel ist.","pagesToNextLevel":"Noch <strong>$t(pages)</strong> zum nächsten Level!","readFirstBookForFirstLevel":"Lies jetzt dein <strong>erstes Buch</strong> um das nächste Level zu erreichen.","readFirstBookForFirstLevelWithCertificate":"$t(readFirstBookForFirstLevel) und <strong>eine Urkunde</strong> zu erhalten.","scanSuccess":{"addedPages":"Du hast damit <strong>$t(pages) ({{count, stacksize, unit}})</strong> zu deinem Bücherstapel hinzugefügt.","addedPages_causedLevel":"Du hast damit <strong>$t(pages) ({{count, stacksize, unit}})</strong> zu deinem Bücherstapel hinzugefügt und darfst dich jetzt <strong>{{causedLevel.name}}</strong> nennen.","addedPages_zero":"Leider haben wir keine Information wie viele Seiten dieses Buch beinhaltet. Bitte wende dich an deine Schulmediothek."},"student":{"readPages":"{{name}} hat schon $t(pages) gelesen. Der Bücherstapel von {{name}} ist {{count, stacksize, unit}} hoch.","readPages_zero":"{{name}} hat im Projekt noch kein Buch gelesen. Sobald {{name}} ein Buch erfasst hat, wird hier die Höhe des Bücherstapels angezeigt."},"class":{"readPages":"Deine {{name}} hat schon $t(pages) gelesen. Der Bücherstapel deiner {{name}} ist {{count, stacksize, unit}} hoch."},"school":{"readPages":"$t(class.readPages)"},"authError":{"INVALID_CREDENTIALS":"E-Mail-Adresse oder Passwort falsch","NOT_ALLOWED":"Keine Zugangsberechtigung"}}');
;// CONCATENATED MODULE: ./src/locales/de/errors.json
var errors_namespaceObject = JSON.parse('{"default":"Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt noch einmal.","required":"Dieses Feld ist ein Pflichtfeld","survey":{"required":"Bitte wähle eine Antwort aus."},"runtime":{"1658943826":"Dieses Buch wurde bereits von dir für NEXT LEVEL gewertet.","1658945694":"Dieses Buch kannst du nicht für NEXT LEVEL werten, weil du es nicht entliehen hast.","1658945928":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in.","1661857824":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in.","1662733460":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an Dein:e Schulbibliothekar:in."},"precondition-failed":{"media not lent":"Dieses Buch kannst du nicht für NEXT LEVEL werten, weil du es nicht entliehen hast.","media-group invalid":"Dieser Titel kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an deine Schulbibliothekarin.","media-classification not allowed":"Dieses Buch kann für NEXT LEVEL nicht gewertet werden. Bitte wende dich an deine Schulbibliothekarin.","media already scanned":"Das Buch scheint nicht auf deine Konto verbucht zu sein. Bitte wende dich an deine Schulbibliothekarin.","media already in library":"Dieses Buch wurde bereits von dir für NEXT LEVEL gewertet."},"not-found":{"9633425e-8d52-48a0-bf1f-de4eb9124b06":"Dieses Buch kannst du nicht für NEXT LEVEL werten, da es nicht aus einer teilnehmenden Bibliothek kommt."}}');
;// CONCATENATED MODULE: ./src/locales/de/layout.json
var layout_namespaceObject = JSON.parse('{"header":{"links":{"login":"Anmelden","register":"Registrieren"}},"footer":{"links":{"imprint":"Impressum","privacyProtection":"Datenschutz"},"supportedBy":"NEXT LEVEL wird unterstützt durch die","realizedBy":"und umgesetzt von"}}');
;// CONCATENATED MODULE: ./src/locales/de/management.json
var management_namespaceObject = JSON.parse('{"readAchievementProbe":{"check":{"not found":"Mediennummer in der Datenbank vorhanden","media not lent":"Verfügbarkeit","media-group invalid":"Mediengruppe","media-classification not allowed":"Klassifikation","media already in library":"Vom Schüler noch nicht erfasst","media already scanned":"Nicht innerhalb des Zeitraumes von einem anderen Schüler erfasst"},"alreadyExists":{"media already in library":"Am {{ offendingReadAchievement.createTime, datetime }} Uhr vom Schüler erfasst","media already scanned":"Am {{ offendingReadAchievement.createTime, datetime }} Uhr von einem anderen Schüler erfasst"},"value":{"media already in library":"Vom Schüler noch nicht erfasst","media already scanned":"Nicht von einem anderen Schüler erfasst"}},"levelNotification":{"certificate":{"actionText":"Urkunde ausstellen","highlightColor":"accent-1"},"letter-teacher":{"actionText":"Brief von der Klassenleitung","highlightColor":"neutral-3"},"school-report":{"actionText":"positive Bewertung auf dem Zeugnis","highlightColor":"accent-3"},"letter-headmaster":{"actionText":"Brief von der Schulleitung","highlightColor":"accent-4"}}}');
;// CONCATENATED MODULE: ./src/locales/de/page_homepage.json
var page_homepage_namespaceObject = JSON.parse('{"hero":{"title":"NEXT LEVEL","subtitle":"die App der Schulmediotheken Gütersloh","steps":{"1":"<strong>Lies ein Buch</strong> aus Deiner Schulmediothek.","2":"<strong>Fertig gelesen?</strong> <br> Dann scanne die Mediennummer des Buches.","3":"Und steige damit ins <strong>nächste Level</strong> auf!"},"cta":{"login":"Einloggen","register":"Neu registrieren"}},"intro":{"text":"Die App <strong>NEXT LEVEL</strong> zählt alle gelesenen Seiten zusammen und zeigt Euch, wie viel ihr insgesamt gelesen habt. Nehmt als ganze Klasse teil und lasst euren Bücherstapel schnell in die Höhe wachsen!"},"stats":{"stackHeight":{"unit":"<number>{{height}}</number> Meter","description":"hoher Bücherstapel","currentYear":"davon im aktuellen Schuljahr"},"readPages":{"description":"gelesene Seiten","currentYear":"davon im aktuellen Schuljahr"},"schools":{"unit_one":"{{count, number}} Schule","unit_other":"{{count, number}} Schulen","description":"nehmen am <br> Projekt teil"},"students":{"unit":"{{count, number}} Schüler:innen","description":"machen schon mit"}},"nextStudent":{"headline":"Bist du als nächstes dabei?","cta":"Jetzt registrieren"},"currentBooks":{"headline":"Was aktuell <br> gelesen wird"}}');
;// CONCATENATED MODULE: ./src/locales/de/readingHabits.json
var readingHabits_namespaceObject = JSON.parse('{"readsInFreeTime":{"question":"Liest du in Deiner Freizeit Bücher? (Mangas sind Bücher.)","answers":{"YES":"Ja","NO":"Nein"}},"nativeSpeaker":{"question":"Ist Deutsch deine Muttersprache?","answers":{"YES":"Ja","NO":"Nein"}},"readingSkill":{"question":"Kannst du gut und flüssig lesen oder ist das Lesen für dich noch anstrengend?","answers":{"LOW":"Lesen ist für mich schwierig. Ich muss Sätze manchmal zweimal lesen, um sie zu verstehen.","GOOD":"Ich kann gut lesen. Nur bei fremden Texten und unbekannten Wörtern habe ich Schwierigkeiten.","FLUENT":"Ich kann flüssig lesen, auch fremde Texte."}},"booksReadYearly":{"question":"Wie viele Bücher liest du pro Jahr?","answers":{"ZERO_TO_FIVE":"0 bis 5","FIVE_TO_TEN":"6 bis 10","TEN_TO_FIFTEEN":"11 bis 15","MORE_THAN_FIFTEEN":"mehr als 15"}},"readingRelatives":{"question":"Wer aus Deiner Familie liest gerne? (Mehrfachantworten möglich.)","answers":{"FATHER":"Vater","MOTHER":"Mutter","SIBLING":"Geschwister","GRANDMOTHER":"Opa","GRANDFATHER":"Oma","NONE":"niemand"}}}');
;// CONCATENATED MODULE: ./src/locales/de/validation.json
var validation_namespaceObject = JSON.parse('{"notEmpty":"Das Feld darf nicht leer sein.","boolean":"Dieses Feld muss aktiviert werden.","email":"Ungültige E-Mail-Adresse.","passwordMinLength":"Das Password muss mindestens {{count}} Zeichen haben.","passwordRepeat":"Die Passwörter stimmen nicht überein."}');
;// CONCATENATED MODULE: ./src/locales/de/index.ts












;// CONCATENATED MODULE: ./src/locales/index.ts



// EXTERNAL MODULE: ./src/utilities/bookStack.ts
var bookStack = __webpack_require__(70545);
// EXTERNAL MODULE: ./src/utilities/Format/number.ts
var number = __webpack_require__(42729);
;// CONCATENATED MODULE: ./src/i18n.ts

var ref, ref1, ref2, ref3;

// eslint-disable-next-line import/no-internal-modules






i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({
    resources: {
        de: de_namespaceObject
    },
    lng: "de",
    fallbackLng: "de",
    defaultNS: "common"
});
(ref = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref === void 0 ? void 0 : ref.add("unit", function(value, lng, options) {
    return (0,number/* formatUnit */.A)(value, lng || options.fallbackLng);
});
(ref1 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref1 === void 0 ? void 0 : ref1.add("stacksize", function(value) {
    if (typeof value !== "number") {
        throw new Error("value passed is not a number");
    }
    return (0,bookStack/* getStackHeightInMM */.V)(value).toString(10);
});
(ref2 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref2 === void 0 ? void 0 : ref2.add("parsedate", function(value) {
    if (typeof value === "undefined") {
        console.error("undefined passed to parsedate-formatter");
    }
    if ((0,_instanceof/* default */.Z)(value, Date)) {
        return value;
    }
    return (0,parseISO/* default */.Z)(value);
});
(ref3 = i18next/* default.services.formatter */.ZP.services.formatter) === null || ref3 === void 0 ? void 0 : ref3.add("datetorelative", function(value, _lng) {
    if (!(0,_instanceof/* default */.Z)(value, Date)) {
        console.error("non-date passed to datetorelative-formatter");
        return "";
    }
    return (0,formatRelative/* default */.Z)(value, new Date(), {
        locale: de/* default */.Z
    });
});
/* harmony default export */ var src_i18n = ((/* unused pure expression or super */ null && (i18n)));



/***/ }),

/***/ 42729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ formatUnit; },
/* harmony export */   "u": function() { return /* binding */ formatNumber; }
/* harmony export */ });
var formatUnit = function(value, lng) {
    var numberFormatter = new Intl.NumberFormat(lng, {
        maximumFractionDigits: 2
    });
    // to start value is in mm
    if (value > 1000) {
        return "".concat(numberFormatter.format(value / 1000), " m");
    }
    if (value > 10) {
        return "".concat(numberFormatter.format(value / 10), " cm");
    }
    return "".concat(numberFormatter.format(value), " mm");
};
var formatNumber = function(value) {
    var lng = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "de";
    var numberFormatter = new Intl.NumberFormat(lng, {
        maximumFractionDigits: 2
    });
    return numberFormatter.format(value);
};


/***/ }),

/***/ 70545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getStackHeightInMM; }
/* harmony export */ });
var GRAMMAGE = 135;
var VOLUME_FACTOR = 1.3;
function getStackHeightInMM(pages) {
    return pages / 2 * GRAMMAGE * VOLUME_FACTOR / 1000;
}


/***/ })

}]);